import React from 'react';
import { SectionHeading } from './SectionHeading';
import { whatIfCategories, whatIfNoNeed } from '../data/content';
export function WhatIfSection() {
  return <section className="bg-cream px-4 py-6 sm:px-6" data-id="element-253" data-mp="2i6oerqxq0jdw">
      <SectionHeading size="lg" data-id="element-254" data-mp="2e3rqbjli1t21">
        What if your next senior activity was already ready?
      </SectionHeading>

      <ul className="mx-auto mt-3 max-w-xl space-y-1" data-id="element-255" data-mp="29585jmin6nb9">
        {whatIfNoNeed.map(line => <li key={line} className="border-l-4 border-terracotta bg-white px-3 py-1.5 text-[13px] font-semibold leading-snug text-graphite" data-id="element-256" data-mp="35tefmoyc27wx">
            {line}
          </li>)}
      </ul>

      <p className="mt-3 text-center font-heading text-lg font-extrabold uppercase text-terracotta sm:text-xl" data-id="element-257" data-mp="2wz9ijnslw08y">
        You need a system.
      </p>

      <ul className="mt-3 flex flex-wrap justify-center gap-1.5" data-id="element-258" data-mp="3piyjrm3h6rym">
        {whatIfCategories.map(category => <li key={category} className="rounded-full border border-navy/20 bg-white px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-navy sm:text-xs" data-id="element-259" data-mp="3kply9ku3f1a3">
            {category}
          </li>)}
      </ul>

      <p className="mx-auto mt-3 max-w-2xl text-center text-[13px] font-medium leading-snug text-graphite sm:text-sm" data-id="element-260" data-mp="2vw7pcs07dua9">
        <strong className="font-extrabold text-navy" data-id="element-261" data-mp="2zw830afha1g9">
          SENIOR ACTIVITY READY™
        </strong>{' '}
        gives you one complete professional system to choose, adapt, organize and
        deliver engaging senior activities without constantly starting from a
        blank page.
      </p>
    </section>;
}